import { useState } from "react";
import axios from "axios";



function Login() {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (e) => {

    e.preventDefault();

    try {

      console.log("Axio Run");
      // https://saleupcall.com/api/login.php
      // http://localhost:8081/saleupcallved-backend/login.php
      const response = await axios.post(
        "https://saleupcall.com/api/login.php",
        {
          email,
          password
        }
      );

      console.log("Axio Ran");

      console.log(response.data);

      if(response.data.status){

        console.log("User Object:",response.data.user);
        console.log("User ID:",response.data.user.id);

        localStorage.setItem(
          "token",
          response.data.token
        );
        
        localStorage.setItem(
        "role_id",
        response.data.user.role_id
        );

         localStorage.setItem(
        "username",
        response.data.user.username
        );

         localStorage.setItem(
      "client_id",
      response.data.user.id
    );

        alert("Login Success");
        //window.location.href = "/dashboard";
        window.location.reload();

      } else {
        alert(response.data.message);
      }

    } catch(error){
      console.log(error);
    }

  };

  return (

    <div style={{padding: "40px"}}>

      <h2>Login</h2>

      <form onSubmit={handleLogin}>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e)=>setEmail(e.target.value)}
        />

        <br /><br />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e)=>setPassword(e.target.value)}
        />

        <br /><br />

        <button type="submit">
          Login
        </button>

      </form>

    </div>

  );

}

export default Login;